/**
 * Gallery Lightbox Initialization
 * Uses fslightbox library for accessible image viewing
 */

document.addEventListener('DOMContentLoaded', function() {
    // fslightbox auto-initializes on page load
    // This script handles any additional setup if needed
    
    // Refresh lightboxes if content is dynamically loaded
    if (typeof refreshFsLightbox === 'function') {
        refreshFsLightbox();
    }
    
    // Add keyboard navigation hints
    const galleryItems = document.querySelectorAll('.gallery-grid__item');
    
    galleryItems.forEach((item, index) => {
        // Ensure proper focus styles
        item.addEventListener('focus', function() {
            this.classList.add('gallery-grid__item--focused');
        });
        
        item.addEventListener('blur', function() {
            this.classList.remove('gallery-grid__item--focused');
        });
        
        // Handle Enter key for accessibility
        item.addEventListener('keydown', function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                this.click();
            }
        });
    });
});
